import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { PageSpinner } from '@/components/ui';
import type { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  requireBarAccess?: boolean;
}

export function ProtectedRoute({
  children,
  requireAdmin = false,
  requireBarAccess = false,
}: ProtectedRouteProps) {
  const { isAuthenticated, isAdmin, hasBarAccess, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requireBarAccess && !hasBarAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
